import { makeObservable, observable } from 'mobx';
import {  observer } from 'mobx-react';
import React from 'react';
import CardConteudo from './CardConteudo';
import CardHeader from './CardHeader';
import UsuarioStore from '../../store/UsuarioStore';
import './css/card.css';
import { ControleGabinete, TipoControle } from '../../modelo';
import ControleGabineteStore from '@/store/ControleGabineteStore';
import ProcessoStore from '@/store/ProcessoStore';

interface ICardProps {
    card: ControleGabinete;
    isConfig: boolean;
    visualizandoKanban: boolean;
    index: number;
}


class Card extends React.Component<ICardProps> {
    mostrarBotoes = false;

    constructor(props: ICardProps) {
        super(props);

        makeObservable(this, {
            mostrarBotoes: observable,});
    }

    get deveExibirBusca() {
        const termo = ControleGabineteStore.termoBuscaDebounced
            ?.trim()
            .toLowerCase();

        if (!termo) return true;

        if (this.props.card.descricao?.toLowerCase().includes(termo)) {
            return true;
        }

        const servidores =
            ControleGabineteStore.servidoresPorControle.get(
                this.props.card.numero
            );

        if (!servidores || servidores.length === 0) {
            return false;
        }

        return servidores.some(nome => nome.includes(termo));
    }

    get deveExibir() {
        const visAtiva = ControleGabineteStore.visibilidadeAtiva;
        const filtroOJC = ControleGabineteStore.filtroOJC;

        if (visAtiva) {
            return true;
        }

        if (!filtroOJC) {
            return true;
        }

        if (this.props.card.tipo.id !== TipoControle.LISTAGEM) {
            return false;
        }

        return ProcessoStore.processosDoControle(
            this.props.card.numero,
            true,
            filtroOJC
        ).length > 0;
    }

    renderEmBloco() {
        return (
            <div className="card-display">
                <div className='aligner'>
                    <CardHeader
                        card={this.props.card}
                        isConfig={this.props.isConfig}
                        index={this.props.index}
                    />

                    <CardConteudo
                        card={this.props.card}
                        visualizandoKanban={this.props.visualizandoKanban}
                        isConfig={this.props.isConfig}
                        apenasProcessos={UsuarioStore.visualizarProcessos}
                    />
                </div>
            </div>
        );
    }

    renderEmLista() {
        return (
            <div className="card-lista">
                <div className="card-lista-header">
                    <CardHeader
                        card={this.props.card}
                        isConfig={this.props.isConfig}
                        index={this.props.index}
                    />
                </div>

                <div className="card-lista-conteudo">
                    <CardConteudo
                        card={this.props.card}
                        visualizandoKanban={this.props.visualizandoKanban}
                        isConfig={this.props.isConfig}
                        apenasProcessos={UsuarioStore.visualizarProcessos}
                    />
                </div>
            </div>
        );
    }

    render() {
        if (!this.deveExibir) {
            return null;
        }

        const estiloBusca = this.deveExibirBusca
            ? { display: 'contents' }
            : { display: 'none' };

        return (
            <div style={estiloBusca}>
                {ControleGabineteStore.isVisualizacaoEmLista
                    ? this.renderEmLista()
                    : this.renderEmBloco()}
            </div>
        );
    }
}

export default observer(Card);
